import React from 'react'

const Contact = () => {
    return (
        <div id="Contact" className="section skills project-div">
            <div className="flex flex-col items-center justify-center  ">
                <p className="cursive title-top">Contact Me</p>
                <p className="pb-2 pl-4 font-medium sm:text-lg">
                    Feel free to reach out if you want to build something together, have a question, or just want to connect.                </p>
                <a
                    className="underline underline-offset-4"
                    href="mailto:janhavialekar@gmail.com"
                >
                    janhavialekar@gmail.com
                </a>
            </div>
            {/* <h1>Section 2</h1> */}
            {/* <Hero /> */}
            {/* <a href="#Project" className="js-anchor-link">
      Go to section 3
    </a> */}
        </div>
    )
}

export default Contact